import React from 'react';
import config from '~/config';

function LoginAndSignup({ t, lng }) {
  let loginURL, signupURL;
  if (process.browser) {
    loginURL = `${
      config.ssoServerUrl
    }/login?lang=${lng}&serviceURL=${encodeURIComponent(window.location.href)}`;
    signupURL = `${
      config.ssoServerUrl
    }/signup?lang=${lng}&serviceURL=${encodeURIComponent(
      window.location.href,
    )}`;
  }

  return (
    <div>
      {process.browser && (
        <div
          className="action-login"
          dangerouslySetInnerHTML={{
            __html: t(config.getPrefixContent('login_or_signup'), {
              loginURL,
              signupURL,
            }),
          }}
        />
      )}
      <style jsx>
        {`
          .action-login {
            ${config.isIllustAC()
              ? `font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              text-align: center;
              margin: 8px 0;`
              : 'margin-top: 16px;'}
          }
        `}
      </style>
    </div>
  );
}

export default LoginAndSignup;
